import xhrService from "../xhrService";
const baseUrl = "/api/roles";

export const rolesApi = {
  index: () => {
    return xhrService.get(baseUrl).then(response => response.data);
  },
  inspectorRole: (divId) => {
    return xhrService.get(`/api/roles/${divId}/inspectorRole`)
  },
  primaryContactRole: (projectId) => {
    return xhrService.get(`/api/roles/${projectId}/primaryContactRole`)
  },
  primaryContactDropdown: (divId) => {
    return xhrService.get(`/api/roles/primaryContactDropdown/${divId}`)
  },
  getAllRoles: () => {
    return xhrService.get(`${baseUrl}/getAllRoles`).then(response => response.data);
  },
  getRolesByTenant: (tenantId) => {
    return xhrService.get(`${baseUrl}/getRolesByTenant/${tenantId}`).then(response => response.data);
  },
  getRolesWithStatus: ()  => {
    return xhrService.get(`${baseUrl}/getRolesWithStatus`).then(response => response.data);
  },
  updateTenantRoles: (data) => {
    return xhrService.post(`${baseUrl}/updateTenantRoles`, data).then(response => response.data);
  }
};

export default rolesApi;
